/**
 * How a salesperson is addressed in a URL.
 *
 * Most sellers come from HIKE with a staff id, and that id is the key. Some
 * historical sales carry only a typed-in name, and the API matches those by
 * name *and* the absence of an id — so the route marks them with a leading
 * `~`, keeping the two kinds of row distinct even when the name is identical.
 */
export interface PersonRef {
  salesPersonId: string | null
  name: string | null
}

export function personKey(row: { sales_person_id: string | null; name: string }): string {
  return row.sales_person_id ?? `~${encodeURIComponent(row.name)}`
}

export function parsePersonKey(key: string): PersonRef {
  if (key.startsWith('~')) {
    return { salesPersonId: null, name: decodeURIComponent(key.slice(1)) }
  }
  return { salesPersonId: key, name: null }
}
